import getField from '@form/formGenerator'

export const mairieMissionSaveUrl = `${import.meta.env.VITE_API_URL}/api/missions/save`

const mairieMissionFormFields = (
  step,
  missionMairieFormObject,
  errors,
  updateFormObject,
  updateFormObjectProp,
  saveForm,
  isLoading,
  t,
  creationModalCaller,
  data
) => {
  const { coOwnershipPayment, companyPayment, defaultPayment } = missionMairieFormObject.paymentConfig

  let fields = []

  fields['mairie'] = [{
    type: 'select',
    name: 'mairie',
    label: t('form.mission_mairie'),
    value: typeof missionMairieFormObject.mairie === 'object' ? missionMairieFormObject.mairie.id : missionMairieFormObject.mairie,
    key: 'missionMairieFormObject-mairie',
    cssClass: 'mission-mairie column is-6',
    withIcon: false,
    help: t('help.mission_mairie_help'),
    canCreate: true,
    creationModalCaller: () => creationModalCaller('mairie', 'mairies'),
    options: data.mairies,
    disabled: false,
    error: [],
    isRequired: true
  }, {
    type: 'text',
    name: 'addressComplement',
    label: t('form.address_complement'),
    value: missionMairieFormObject.addressComplement,
    key: 'missionMairieFormObject-addressComplement',
    cssClass: 'column is-6',
    isRequired: true,
    help: t('form.address_complement_help'),
  }]

  fields['responsible'] = [{
    type: 'text',
    name: 'responsibleFullName',
    label: t('form.responsible_full_name'),
    value: missionMairieFormObject.responsibleFullName,
    key: 'missionMairieFormObject-responsibleFullName',
    cssClass: 'column is-12',
    isRequired: true
  },
  {
    type: 'text',
    name: 'responsiblePhone',
    label: t('form.responsible_phone'),
    value: missionMairieFormObject.responsiblePhone,
    key: 'missionMairieFormObject-responsiblePhone',
    cssClass: 'column is-12',
    isRequired: true
  },
  {
    type: 'text',
    name: 'responsibleEmail',
    label: t('form.responsible_email'),
    value: missionMairieFormObject.responsibleEmail,
    key: 'missionMairieFormObject-responsibleEmail',
    cssClass: 'column is-12',
    isRequired: true
  }, {
    type: 'select',
    name: 'city',
    label: t('form.mission_city'),
    value: typeof missionMairieFormObject.city === 'object' ? missionMairieFormObject.city.id : missionMairieFormObject.city,
    key: 'missionMairieFormObject-city',
    cssClass: 'mission-city column is-6',
    withIcon: false,
    help: t('help.mission_city_help'),
    canCreate: true,
    creationModalCaller: () => creationModalCaller('city', 'cities'),
    options: data.cities,
    disabled: false,
    error: [],
    isRequired: true
  },
  {
    type: 'number',
    name: 'zipCode',
    label: t('form.zip_code'),
    value: missionMairieFormObject.zipCode,
    key: 'missionMairieFormObject-zipCode',
    cssClass: 'column is-6',
    isRequired: true
  }, {
    type: 'checkbox',
    name: 'missionSubjects',
    label: t('form.mission_subjects'),
    key: 'missionMairieFormObject-missionSubjects',
    cssClass: 'column is-12',
    options: data.missionSubjects,
    canCreate: true,
    creationModalCaller: () => creationModalCaller('missionSubject', 'missionSubjects'),
    isMultiple: true,
    value: missionMairieFormObject.missionSubjects,
    isRequired: true
  }]

  fields['mission'] = [{
    type: 'text',
    name: 'missionTitle',
    label: t('form.mission_title'),
    value: missionMairieFormObject.missionTitle,
    key: 'missionMairieFormObject-missionTitle',
    cssClass: 'column is-12',
    isRequired: true
  }, {
    type: 'hugerte',
    config: 'min',
    name: 'externalLink',
    label: t('form.external_link'),
    help: t('form.external_link_help'),
    height: 200,
    disabled: false,
    initialValue: missionMairieFormObject.externalLink,
    key: 'missionMairieFormObject-externalLink',
    cssClass: 'column is-12'
  }, {
    type: 'hugerte',
    config: 'min',
    name: 'legalInformation',
    label: t('form.legal_information'),
    help: t('form.legal_information_help'),
    height: 200,
    disabled: false,
    initialValue: missionMairieFormObject.legalInformation,
    key: 'missionMairieFormObject-legalInformation',
    cssClass: 'column is-12'
  }, {
    type: 'file',
    name: 'missionLogo',
    blobPoster: missionMairieFormObject.missionLogo ?? false,
    cssClass: 'column is-6 mission-logo',
    simpleInput: false,
    key: 'missionMairieFormObject-missionLogo',
    disabled: false,
    label: t('form.mission_logo'),
    targetUrl: `${import.meta.env.VITE_API_URL}/api/push/temp-files`,
    isRequired: true
  }, {
    type: 'text',
    name: 'language',
    label: t('form.default_language'),
    help: t('form.default_language_help'),
    value: missionMairieFormObject.language,
    key: 'missionMairieFormObject-language',
    cssClass: 'column is-12'
  }, {
    type: 'text',
    name: 'supportedLanguages',
    label: t('form.supported_languages'),
    help: t('form.supported_languages_help'),
    value: missionMairieFormObject.supportedLanguages,
    key: 'missionMairieFormObject-supportedLanguages',
    cssClass: 'column is-12'
  }]

  fields['missionOptions'] = [{
    type: 'text',
    name: 'missionUrl',
    label: t('form.mission_url'),
    help: t('form.mission_url_help'),
    value: missionMairieFormObject.missionUrl,
    key: 'missionMairieFormObject-missionUrl',
    cssClass: 'column is-12',
    isRequired: true
  }, {
    type: 'textarea',
    name: 'specialStyle',
    label: t('form.special_style'),
    value: missionMairieFormObject.specialStyle,
    key: 'missionMairieFormObject-specialStyle',
    cssClass: 'column is-12'
  },
  {
    type: 'switcher',
    name: 'isActive',
    label: t('form.mission_is_active'),
    value: missionMairieFormObject.isActive,
    cssClass: 'column is-12',
    key: 'missionMairieFormObject-isActive',
    id: 'missionMairieFormObject-isActive',
  },
  {
    type: 'switcher',
    name: 'isMultipleCities',
    label: t('form.mission_is_multiple_cities'),
    value: missionMairieFormObject.isMultipleCities,
    cssClass: 'column is-12',
    key: 'missionMairieFormObject-isMultipleCities',
    id: 'missionMairieFormObject-isMultipleCities',
  }]

  fields['defaultPayment'] = [{
    type: 'switcher',
    name: 'paymentConfig.defaultPayment.isBilled',
    label: t('form.mission_billed'),
    value: defaultPayment?.isBilled,
    key: 'missionMairieFormObject-isBilled',
    cssClass: 'column is-12',
    id: 'missionMairieFormObject-isBilled'
  }, {
    type: 'switcher',
    name: 'paymentConfig.defaultPayment.isOnlinePaymentRequired',
    label: t('form.mission_online_payment_required'),
    value: defaultPayment?.isOnlinePaymentRequired,
    cssClass: `column is-12 ${!parseInt(defaultPayment?.isBilled) ? 'is-hidden' : ''}`,
    key: 'missionMairieFormObject-paymentConfig-defaultPayment-isOnlinePaymentRequired',
  }, {
    type: 'radio',
    name: 'paymentConfig.defaultPayment.billingType',
    label: t('form.default_billing_type'),
    key: 'missionMairieFormObject-paymentConfig.defaultPayment.billingType',
    cssClass: 'column is-12',
    options: data.billingTypes,
    canCreate: true,
    creationModalCaller: () => creationModalCaller('billingType', 'billingTypes'),
    isMultiple: true,
    value: defaultPayment?.billingType,
    isRequired: false
  }]

  fields['companyPayment'] = [{
    type: 'switcher',
    name: 'isCompany',
    label: t('form.mission_company'),
    value: missionMairieFormObject.isCompany,
    cssClass: 'column is-12',
    key: 'missionMairieFormObject-isCompany'
  },
  {
    type: 'switcher',
    name: 'paymentConfig.companyPayment.isBilled',
    label: t('form.mission_company_billed'),
    value: companyPayment?.isBilled,
    cssClass: `column is-12 ${!parseInt(missionMairieFormObject.isCompany) ? 'is-hidden' : ''}`,
    key: 'missionMairieFormObject-paymentConfig-company-isBilled',
  }, {
    type: 'switcher',
    name: 'paymentConfig.companyPayment.isOnlinePaymentRequired',
    label: t('form.mission_online_payment_required'),
    value: companyPayment?.isOnlinePaymentRequired,
    cssClass: `column is-12 ${!parseInt(companyPayment?.isBilled) ? 'is-hidden' : ''}`,
    key: 'missionMairieFormObject-paymentConfig-company-isOnlinePaymentRequired',
  }, {
    type: 'radio',
    name: 'paymentConfig.companyPayment.billingType',
    label: t('form.company_billing_type'),
    key: 'missionMairieFormObject-paymentConfig.companyPayment.billingType',
    cssClass: `column is-12 ${!parseInt(companyPayment?.isBilled) ? 'is-hidden' : ''}`,
    options: data.billingTypes,
    canCreate: true,
    creationModalCaller: () => creationModalCaller('billingType', 'billingTypes'),
    isMultiple: true,
    value: companyPayment?.billingType,
    isRequired: false
  }]

  fields['coOwnershipPayment'] = [{
    type: 'switcher',
    name: 'isCoOwnership',
    label: t('form.mission_co_ownership'),
    value: missionMairieFormObject.isCoOwnership,
    cssClass: 'column is-12',
    key: 'missionMairieFormObject-isCoOwnership'
  }, {
    type: 'switcher',
    name: 'paymentConfig.coOwnershipPayment.isBilled',
    label: t('form.mission_co_ownership_billed'),
    value: coOwnershipPayment?.isBilled,
    cssClass: `column is-12 ${!parseInt(missionMairieFormObject.isCoOwnership) ? 'is-hidden' : ''}`,
    key: 'missionMairieFormObject-paymentConfig-coOwnership-isBilled',
  }, {
    type: 'switcher',
    name: 'paymentConfig.coOwnershipPayment.isOnlinePaymentRequired',
    label: t('form.mission_online_payment_required'),
    value: coOwnershipPayment?.isOnlinePaymentRequired,
    cssClass: `column is-12 ${!parseInt(coOwnershipPayment?.isCoOwnership) ? 'is-hidden' : ''}`,
    key: 'missionMairieFormObject-paymentConfig-coOwnership-isOnlinePaymentRequired',
  }, {
    type: 'radio',
    name: 'paymentConfig.coOwnershipPayment.billingType',
    label: t('form.company_billing_type'),
    key: 'missionMairieFormObject-paymentConfig.coOwnershipPayment.billingType',
    cssClass: `column is-12 ${!parseInt(coOwnershipPayment?.isBilled) ? 'is-hidden' : ''}`,
    options: data.billingTypes,
    canCreate: true,
    creationModalCaller: () => creationModalCaller('billingType', 'billingTypes'),
    isMultiple: true,
    value: coOwnershipPayment?.billingType,
    isRequired: false
  }]

  fields['submit'] = [{
    type: 'button',
    buttons: true,
    callback: saveForm,
    cancel: false,
    validateText: t('form.save'),
    cssClassParent: 'column is-12',
    cssClassValidate: 'button is-blue',
    validateIcon: 'icon-done',
    key: 'missionMairieFormObject-form',
    isLoading
  },
  {
    type: 'hidden',
    name: 'id',
    value: parseInt(missionMairieFormObject.id),
    key: 'missionMairieFormObject-id'
  }]

  return fields[step].map(function (field) {
    return getField({ ...field, error: errors[field.name] ? errors[field.name].errors : '' }, updateFormObject, updateFormObjectProp)
  })
}

export const missionFormObject = {
  mairie: '',
  responsibleFullName: '',
  responsibleEmail: '',
  responsiblePhoneNumber: '',
  missionResponsibleFullName: '',
  missionResponsibleEmail: '',
  missionResponsiblePhoneNumber: '',
  companyName: '',
  companyTvaNumber: '',
  missionAddress: '',
  city: '',
  district: '',
  zipCode: '',
  firstScanStartsAt: '',
  firstScanEndsAt: '',
  firstScanPilots: '',
  secondScanStartsAt: '',
  secondScanEndsAt: '',
  secondScanPilots: '',
  id: '',
  firstScanpilots: '',
  secondScanpilots: '',
  logo: '',
  missionTitle: '',
  missionDescription: '',
  companyBillingPriceM2: '',
  isCoOwnership: false,
  isCompany: false,
  isActive: false,
  isMultipleCities: false,
  addressComplement: '',
  externalLink: '',
  billingType: '',
  paymentConfig: {
    defaultPayment: {
      isBilled: false,
      billingType: null,
      isOnlinePaymentRequired: false
    },
    companyPayment: {
      isCompanyBilled: false,
      billingType: null,
      isOnlinePaymentRequired: false
    },
    coOwnershipPayment: {
      isCoOwnershipBilled: false,
      billingType: null,
      isOnlinePaymentRequired: false
    }
  }
}

export default mairieMissionFormFields